"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thirdPartyRegistry = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
const name = 'Decentraland Third Party Registry';
exports.thirdPartyRegistry = {
    [schemas_1.ChainId.MATIC_MUMBAI]: {
        version: '1',
        abi: abis_1.abis.ThirdPartyRegistry,
        address: '0xEDf516F2D42A47F9cE0B145Fe0dbB76975379889',
        name,
        chainId: schemas_1.ChainId.MATIC_MUMBAI
    },
    [schemas_1.ChainId.MATIC_MAINNET]: {
        version: '1',
        abi: abis_1.abis.ThirdPartyRegistry,
        address: '0x1C436C1EFb4608dFfDC8bace99d2B03c314f3348',
        name,
        chainId: schemas_1.ChainId.MATIC_MAINNET
    }
};
//# sourceMappingURL=thirdPartyRegistry.js.map